export default "__VITE_PUBLIC_ASSET__ac2d0706__"